import { createFileRoute } from '@tanstack/react-router';

import { matterSchema, type MatterPayload } from '@chariot/core-contracts';

const FIXTURE: unknown = {
  id: '0192f8a0-7c1e-7000-8000-3f2a1b0c9d8e',
  companyId: '0192f8a0-7c1e-7000-8000-000000000001',
  displayNumber: '2026-0042',
};

export const Route = createFileRoute('/_app/')({
  loader: (): MatterPayload => matterSchema.parse(FIXTURE),
  component: MattersPlaceholder,
});

function MattersPlaceholder() {
  const matter = Route.useLoaderData();

  return (
    <section>
      <h2>Matters</h2>
      <p>{matter.displayNumber}</p>
    </section>
  );
}
